import { addSuccessSectionCompany } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useStoreSuccessCompany = () => {
    const queryClient = useQueryClient();
    return useMutation(addSuccessSectionCompany, {
        onSuccess: () => {
            toast.success("Section added sucesfully");
            queryClient.invalidateQueries('monthlySuccess');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}